import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment.development';
import { Amplify } from 'aws-amplify';

Amplify.configure({Auth: environment.cognito});
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
